import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import debugFactory from "debug";
import { TeamingTiptapExtensionType } from "@teaming/common-enums";
import TeamingTiptapDecision from "./TeamingTiptapDecision.vue";
const debug = debugFactory( "teaming:tiptap:decision" );

export default Node.create( {
	name: "teaming-decision",
	content: "text*",
	defining: true,
	group: "block",
	marks: "",
	draggable: true,

	addNodeView() {
		debug( "Executing addNodeView" );
		// eslint-disable-next-line new-cap
		return VueNodeViewRenderer( TeamingTiptapDecision );
	},

	addOptions() {
		return {
			onTeamingExtensionCallback: () => {},
		};
	},

	parseHTML() {
		return [
			{
				tag: "teaming-decision",
			},
		];
	},

	renderHTML( { HTMLAttributes, } ) {
		return [ "teaming-decision", mergeAttributes( HTMLAttributes ), 0, ];
	},

	addCommands() {
		debug( "Executing addCommands" );
		return {
			setDecision: () => ( { commands, } ) => {
				return commands.setNode( this.name );
			},
			toggleDecision: attributes => ( { commands, } ) => {
				return commands.toggleNode( this.name, "paragraph", attributes );
			},
			unsetDecision: () => ( { commands, } ) => {
				return commands.lift( this.name );
			},
		};
	},

	onCreate() {
		const { $anchor, } = this.editor.state.selection;
		if ( $anchor.parent.type.name === this.name ) {
			this.options.onTeamingExtensionCallback( { nodeType: TeamingTiptapExtensionType.DECISION, type: "create", } );
		}
	},

	onUpdate() {
		const { $anchor, } = this.editor.state.selection;
		if ( $anchor.parent.type.name === this.name ) {
			this.options.onTeamingExtensionCallback( { nodeType: TeamingTiptapExtensionType.DECISION, type: "update", } );
		}
	},

} );
